const Splash3 = () => {
  return (
    <div className="w-full relative bg-[#f2ece3] overflow-hidden flex flex-col items-start pt-[74px] pb-3 pl-[100px] pr-[61px] box-border gap-[62px] leading-[normal] tracking-[normal] text-left text-base text-[#353434] font-[Mingzat] mq750:gap-[31px] mq750:pl-[50px] mq750:pr-[30px] mq750:box-border mq450:gap-[15px] mq450:pl-5 mq450:box-border">
      <main className="self-stretch flex items-start gap-[108px] max-w-full mq750:gap-[54px] mq450:gap-[27px] mq1050:flex-wrap">
        <img
          className="w-[600px] relative rounded-[20px] max-h-full object-cover max-w-full mq1050:flex-1"
          loading="lazy"
          alt=""
          src="./Rectangle-6@2x.png"
        />
        <section className="flex-1 flex flex-col items-end gap-[72px] min-w-[418px] max-w-full text-center text-[40px] text-[#fff] font-['Great_Vibes'] mq750:gap-9 mq750:min-w-full mq450:gap-[18px]">
          <div className="flex items-start justify-end pt-0 px-[79px] pb-[74.9px] box-border max-w-full mq450:pl-5 mq450:pr-5 mq450:box-border">
            <div className="flex-1 flex flex-col items-start gap-1.5">
              <div className="self-stretch rounded-[10px] bg-[#1e1e1e] flex items-start pt-2.5 pb-[23px] pl-7 pr-[21px]">
                <div className="h-[104px] w-[244px] relative rounded-[10px] bg-[#1e1e1e] hidden shrink-0" />
                <div className="flex-1 relative z-[1] shrink-0 mq750:text-[32px] mq450:text-2xl">
                  <span>Insta</span>
                  <span className="text-[64px] font-black font-['Kumbh_Sans']">
                    ED
                  </span>
                </div>
              </div>
              <div className="flex items-start py-0 pl-[7px] pr-0.5 text-left text-2xl text-[#000] font-['Maven_Pro']">
                <h3 className="m-0 relative text-[length:inherit] font-normal font-[inherit] mq450:text-[19px]">
                  Online Tuitions | 6-12
                </h3>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start gap-[33.7px] max-w-full text-left text-4xl text-schemes-primary font-[Manrope] mq750:gap-[17px]">
            <div className="flex flex-col items-start gap-[15.3px] max-w-full shrink-0">
              <div className="h-[55px] relative font-extrabold inline-block max-w-full mq750:text-[29px] mq450:text-[22px]">
                <span>Top</span>
                <span className="text-5xl">{` `}</span>
                <span className="text-[64px]">Teachers.</span>
              </div>
              <div className="h-[62px] relative font-extrabold inline-block mq750:text-[29px] mq450:text-[22px]">
                <span>Thoughtful</span>
                <span className="text-[40px]">{` `}</span>
                <span className="text-[64px]">Pedagogy.</span>
              </div>
            </div>
            <div className="h-[88px] relative text-[32px] text-[#000] inline-block mq750:text-[26px] mq450:text-[19px]">
              no ‘AI’. just ‘Real Teachers’
              <br />
              Teaching the way good schools always have
            </div>
          </div>
          <div className="self-stretch flex items-start justify-center py-0 pl-5 pr-44 mq450:pr-5 mq450:box-border">
            <div className="flex flex-col items-end gap-11">
              <div className="flex items-start gap-[15px]">
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#353434] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
              </div>
              <div className="flex items-start justify-end py-0 pl-6 pr-[18px]">
                <button className="cursor-pointer border-[#948d8d] border-solid border-[1px] pt-3.5 pb-4 pl-[29px] pr-6 bg-[#fff] h-[67px] rounded-[5px] box-border flex items-start hover:bg-[#e6e6e6] hover:border-[#7a7373] hover:border-solid hover:hover:border-[1px] hover:box-border">
                  <div className="h-[67px] w-[183px] relative rounded-[5px] bg-[#fff] border-[#948d8d] border-solid border-[1px] box-border hidden shrink-0" />
                  <button className="cursor-pointer [border:none] p-0 bg-[transparent] relative text-2xl font-[Manrope] text-[#000] text-left inline-block z-[1] shrink-0">
                    Get Started
                  </button>
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="flex items-start py-0 px-[463px] box-border max-w-full mq750:pl-[115px] mq750:pr-[115px] mq750:box-border mq450:pl-5 mq450:pr-5 mq450:box-border mq1050:pl-[231px] mq1050:pr-[231px] mq1050:box-border">
        <div className="relative">
          {`2026 |  | `}
          <span className="[text-decoration:underline]">Terms of Use</span>
          {` | `}
          <span className="[text-decoration:underline]">Privacy Policy</span>
        </div>
      </div>
    </div>
  );
};

export default Splash3;
